<template>  
  <format
    :msg="$t('game-others')"
    :type-game="5"
    :src="require('@/assets/nav/submenu/icon_power_ball.svg')"
  />
</template>
<script>  
import format from './childs/format'

export default {

  components : {
    format
  }  
} 
</script> 